import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import { ToolbarListWrapper } from "../ToolbatListWrapper/ToolbarListWrapper";
import ToolbarList from "../ToolbarList/ToolbarList";

export const ToolbarListTableSummary = ({
  campaignId,
  format,
  toolbarListProps,
}) => {
  const {
    reportReducer: { campaigns, summaryStatistics: summaryStatisticsFR },
  } = useSelector((state) => state);

  const { publicationsSummary } = campaigns[campaignId] || {};
  const summaryStatistics = summaryStatisticsFR[campaignId];

  const summaryTables = useMemo(
    () =>
      Object.keys(publicationsSummary || {}).map((provider) => ({
        provider: `table-summary-${provider}-${campaignId}`,
        disableExpanding: !publicationsSummary[provider]?.summary?.length,
      })) || [],
    [publicationsSummary, summaryStatistics],
  );

  return summaryTables.map((item, index) => (
    <ToolbarListWrapper key={item.provider} loading={false}>
      <ToolbarList
        provider={item.provider}
        format={format}
        open={item.open}
        toolbarListProps={toolbarListProps}
        disableExpanding={item.disableExpanding}
        noBottomBorder={index === summaryTables.length - 1}
        isReport
        campaignId={campaignId}
      />
    </ToolbarListWrapper>
  ));
};
